module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"conversion":{"cards":"Calculada com base nas transações de cartão finalizadas com sucesso, incluindo as retentativas."}},"en-US":{"conversion":{"cards":"Calculated based on successfull card transactions, including retries"}}}')
  delete Component.options._Ctor
}
